module.exports = __webpack_public_path__ + "static/media/White.45131812.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/White.png
// module id = 746
// module chunks = 0